var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.880462 21.1587C1.44439 21.6974 2.20914 22 3.00654 22C3.80393 22 4.56868 21.6974 5.13261 21.1587L20.0182 6.93565L34.9037 21.1587C35.4709 21.6821 36.2305 21.9717 37.019 21.9652C37.8074 21.9586 38.5617 21.6565 39.1192 21.1237C39.6768 20.591 39.993 19.8703 39.9999 19.1169C40.0067 18.3635 39.7036 17.6377 39.1558 17.0958L22.1442 0.841277C21.5803 0.302608 20.8156 0 20.0182 0C19.2208 0 18.456 0.302608 17.8921 0.841277L0.880462 17.0958C0.316702 17.6346 0 18.3654 0 19.1273C0 19.8892 0.316702 20.6199 0.880462 21.1587Z",
    fill: "#F0EDE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorScroll);
export default __webpack_public_path__ + "static/media/VectorScroll.f0bc4c74df2b923c52a7ed31a2b9da05.svg";
export { ForwardRef as ReactComponent };